import useScript from 'react-script-hook';

export const SPREEDLY_CHECKOUT_SDK_VERSION = '1.5.1';
export const SPREEDLY_CHECKOUT_SDK_SRC = `https://core.spreedly.com/checkout/sdk/${SPREEDLY_CHECKOUT_SDK_VERSION}/index.js`;
export const SPREEDLY_CHECKOUT_SDK_INTEGRITY =
  'sha384-bdDUeTo9mK8Y25RYuSmsVGLkk/Q3id+6QT6TLWVWxmbfRTtNlUkUR5Oa/ir+Q2R1';

export const useSpreedlyCheckoutSdkScriptLoading = options => {
  const [loading, error] = useScript({
    src: SPREEDLY_CHECKOUT_SDK_SRC,
    integrity: SPREEDLY_CHECKOUT_SDK_INTEGRITY,
    crossOrigin: 'anonymous',
    checkForExisting: true,
    ...options,
  });

  return { loading, error };
};
